module.exports = __webpack_public_path__ + "static/img/6.4d441f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/6.png
// module id = edHw
// module chunks = 1